import React from "react";
import { UtensilsCrossed, Tent, Mountain } from "lucide-react";
import { useTranslation } from "react-i18next";

const CATEGORY_ICONS = {
  food: UtensilsCrossed,
  stay: Tent,
  adventure: Mountain,
};

const LABEL_KEYS = {
  food: "map.eats",
  stay: "map.stays",
  adventure: "map.do",
};

function CategoryFilter({ categories, active, onChange }) {
  const { t } = useTranslation();

  return (
    <div className="flex-shrink-0">
      <div className="flex gap-0.5 bg-th-overlay backdrop-blur-md rounded-full px-1 py-1 shadow-lg border border-th-border">
        <button
          onClick={() => onChange(null)}
          className={`px-2.5 py-1.5 rounded-full text-xs font-semibold transition-all ${
            active === null
              ? "bg-th-accent text-th-bg shadow-md"
              : "text-th-text-sec hover:text-th-text active:bg-th-surface"
          }`}
        >
          {t("map.all")}
        </button>
        {categories.map((cat) => {
          const Icon = CATEGORY_ICONS[cat];
          const label = t(LABEL_KEYS[cat] || cat);
          return (
            <button
              key={cat}
              onClick={() => onChange(active === cat ? null : cat)}
              className={`flex items-center gap-1 px-2 py-1.5 rounded-full text-xs font-semibold transition-all ${
                active === cat
                  ? "bg-th-accent text-th-bg shadow-md"
                  : "text-th-text-sec hover:text-th-text active:bg-th-surface"
              }`}
            >
              {Icon && <Icon size={14} strokeWidth={2.5} />}
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default CategoryFilter;
